export default __webpack_public_path__ + "static/media/3435 utensils side.7dc3d354.png";